/** `Claudius M` → `CM`; one name gives one letter; nothing gives `?`. */
export function personInitials(firstName: string | null | undefined, lastName?: string | null): string {
  const initials = [firstName, lastName]
    .map((part) => part?.trim().charAt(0).toUpperCase() ?? '')
    .join('');
  return initials || '?';
}
